import labels from "@/labels/labels";
import Routes from "@/routes/RouteComponent";
import {
  createContext,
  useDispatch,
  useNavigate,
  useLocation,
  useCallback,
  useEffect,
} from "@/common/hooks";
import { skipToken } from "@reduxjs/toolkit/query";
import debounce from "lodash/debounce";
import uniqueId from "lodash/uniqueId";
import cloneDeep from "lodash/cloneDeep";
import { Navbar, Spinner } from "@/common/components";
import { useGetSettingsQuery } from "@/service/APIService";
import { setSettings } from "@/store/commonSlice";

export const PublicContext = createContext();

const PublicRoute = ({ children }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const cancel = () => navigate(-1);

  const debounceState = useCallback(
    debounce((value, func) => {
      func(value);
    }, 300),
    []
  );
  const debounceErrors = useCallback(
    debounce((value, func) => {
      func(value);
    }, 300),
    []
  );

  const { data: settings, isFetching } = useGetSettingsQuery();

  useEffect(() => {
    if (settings) {
      dispatch(setSettings(settings));
    }
  }, [settings]);

  return (
    <PublicContext.Provider
      value={{
        labels,
        Routes,
        skipToken,
        navigate,
        dispatch,
        location,
        cancel,
        debounceState,
        debounceErrors,
        uniqueId,
        cloneDeep,
      }}
    >
      <>
        {isFetching && <Spinner />}
        <Navbar hideHamburger={true} />
        <main className="container g-0 position-relative">{children}</main>
      </>
    </PublicContext.Provider>
  );
};

export default PublicRoute;
